import React from 'react';
import LoadingBar from 'react-redux-loading-bar';

export default function () {
    return (
        <LoadingBar style={{ height: '3px', backgroundColor: '#FBA318', marginTop: '-2px' }} />
    );
}



// WEBPACK FOOTER //
// ./src/components/atoms/LoadingBar.js